// Public analytics IDs (exposed in client code by design; not secrets).
// Hardcoded on purpose — keeps the integration simple and avoids a Vercel env
// step. These are the same identifiers a raw gtag/pixel snippet would embed.
export const GA4_ID = 'G-260N080LV9';
export const META_PIXEL_ID = '170135295273206';
